import {Button, Dialog, DialogContent, DialogTitle, DialogActions, Typography, Grid, Stack, FormLabel, TextField, RadioGroup, Radio, FormControlLabel, CircularProgress} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import ClearIcon from "@mui/icons-material/Clear";
import { useState } from 'react';
import { useFormik } from 'formik';
import {apipost} from 'src/service/api';

const Pinchecker = (props) => {
    const {open, handleClose, setUserAction} = props;
    const [isLoading, setIsLoading] = useState(false);
    const initialFormValues = {
        values: {
            kraPin: "",
            kenyanNationalId: "",
            pinCheckerValue: "ID",
            resultingKRApin: "",
            resultingClientName: ""
        }
    };
    const checkKRApin = async (values) => {
        setIsLoading(true);
        try {
            let response;
            if (values.pinCheckerValue === "ID") {
                response = await apipost('api/kra/pincheckerbyid', { id: values.kenyanNationalId });
                if (response.status === 200) {
                    formik.values.resultingClientName = response.data?.TaxpayerName || "";
                    formik.values.resultingKRApin = response.data?.TaxpayerPIN || "";
                }
                setUserAction(response)
            }
            else if (values.pinCheckerValue === "Pin"){
                response = await apipost('api/kra/pincheckerbypin', { pin: values.kraPin });
                if (response.status === 200) {
                    formik.values.resultingClientName = response.data?.PINDATA?.Name || "";
                    formik.values.resultingKRApin = response.data?.PINDATA?.KRAPIN || "";
                }
                setUserAction(response)
            }
        } catch (error) {
            console.error("Error checking KRA PIN:", error);
        } finally {
            setIsLoading(false);
        }
    }
    const formik = useFormik({
        initialValues: initialFormValues.values,
        validate: (values) => {
            const errors = {};
            if (formik.values.pinCheckerValue === "ID" && !values.kenyanNationalId) {
                errors.kenyanNationalId = "Kenyan National ID is required";
            }
            if (formik.values.pinCheckerValue === "Pin" && !values.kraPin) {
                errors.kraPin = "KRA PIN is required";
            }
            return errors;
        },
        onSubmit: (values) => {
            checkKRApin(values);
        }
    });
    return (
        <div>
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle
                id="scroll-dialog-title"
                style={{
                display: "flex",
                justifyContent: "space-between",
                }}
            >
            <Typography variant="h6">KRA Pin Checker</Typography>
            <Typography>
                <ClearIcon
                onClick={handleClose}
                style={{ cursor: "pointer" }}
                />
          </Typography>
            </DialogTitle>
            <DialogContent dividers>
                <form>
                    <Grid
                        container
                        rowSpacing={3}
                        columnSpacing={{ xs: 0, sm: 5, md: 4 }}
                    >
                    <Grid item xs={12} sm={12} md={12}>
                        <FormLabel>Check KRA PIN by:</FormLabel>
                        <RadioGroup row name="pinCheckerValue" onChange={formik.handleChange} value={formik.values.pinCheckerValue} defaultValue={"ID"}>
                            <FormControlLabel value="ID" control={<Radio />} label="Check by ID" />
                            <FormControlLabel value="Pin" control={<Radio />} label="Check by Pin" />
                        </RadioGroup>
                    </Grid>
                </Grid>
                {formik.values.pinCheckerValue === "Pin" && (
                    <Grid
                        container
                        rowSpacing={3}
                        columnSpacing={{ xs: 0, sm: 5, md: 4 }}
                    >
                        <Grid item xs={12} sm={12} md={12}>
                            <FormLabel>KRA PIN</FormLabel>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="Enter KRA PIN"
                                name="kraPin"
                                value={formik.values.kraPin}
                                onChange={formik.handleChange}
                                error={!!formik.errors.kraPin}
                                helperText={formik.errors.kraPin}
                            />
                        </Grid>
                    </Grid>
        )}
                {formik.values.pinCheckerValue === "ID" && (
                    <Grid
                        container
                        rowSpacing={3}
                        columnSpacing={{ xs: 0, sm: 5, md: 4 }}
                    >
                        <Grid item xs={12} sm={12} md={12}>
                            <FormLabel>Kenyan National ID</FormLabel>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="Enter Kenyan National ID"
                                name="kenyanNationalId"
                                value={formik.values.kenyanNationalId}
                                onChange={formik.handleChange}
                                error={!!formik.errors.kenyanNationalId}
                                helperText={formik.errors.kenyanNationalId}
                            />
                        </Grid>
                    </Grid>
            )}
            <Typography
                style={{ marginBottom: "8px", marginTop: "5px" }}
                variant="h6"
                >
                Resulting Client Details
                </Typography>
            <Grid
                container
                rowSpacing={3}
                columnSpacing={{ xs: 0, sm: 5, md: 4 }}
            >
                <Grid item xs={12} sm={12} md={12}>
                    <FormLabel>KRA PIN:</FormLabel>
                    <TextField
                        fullWidth
                        size="small"
                        rows={3}
                        value={formik.values.resultingKRApin}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <FormLabel>Client Name:</FormLabel>
                    <TextField
                        fullWidth
                        size="small"
                        multiline
                        rows={3}
                        value={formik.values.resultingClientName}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                </Grid>
            </Grid>
            </form>
            </DialogContent>
            <DialogActions>
            <Stack direction="row" spacing={2}>
                <LoadingButton onClick={formik.handleSubmit} variant='contained' color='secondary' disabled={!!isLoading}>
                {isLoading ? <CircularProgress size={27} /> : 'CHECK'}
                </LoadingButton>
                <Button variant="outlined" color="error" onClick={handleClose}>Cancel</Button>
            </Stack>
            </DialogActions>
        </Dialog>
    </div>
  );
};

export default Pinchecker;